  var products_on_page = $(".products-on-page");
  var next_url = products_on_page.data("next-url");
  var load_more_btn = $(".load-more_btn");
  var load_more_spinner = $(".load-more_spinner");
  function loadMoreProducts(){
    $.ajax(
      {
        url:next_url,
        type:'GET',
        dataType:'html',
        beforeSend: function(){
          load_more_btn.hide();
          load_more_spinner.show();

        }
      }
    ).done(function(next_page){
      console.log("products_on_page" , products_on_page);
       console.log("next_url" , next_url);
      
      load_more_spinner.hide();

      var new_products = $(next_page).find(".products-on-page");
      var new_url = new_products.data('next-url'); 
      console.log("new_url",new_url);
      if(new_url != "data-products-grid")
        load_more_btn.show();
      next_url = new_url;
      products_on_page.append(new_products.html());
    });
  }
